import React, { useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components/macro';
import {
  Button,
  Wrapper,
  Menu,
  MenuItem,
  openMenu,
  closeMenu,
} from 'react-aria-menubutton';
import { responsive } from '../../../resources/constantes.json';
import { useNomenclator } from '../../../contexts/nomenclatorContext';
import {
  nombreEleccion,
  nomEleccionAmbitos,
} from '../../../resources/constantes';
import ButtonArrow from '../../Arrows/ButtonArrow/index.js';
import { useViewContext } from '../../../contexts/viewContext';

const DropdownElecciones = ({ isOpen, setIsOpen, title }) => {
  const nomenclator = useNomenclator();
  const { elections } = useViewContext();
  const wrapperId = `dropdown-elecciones`;
  const { view } = useViewContext();
  const isEstadisticas = view === 'estadisticas';

  const propiedades = isEstadisticas
    ? nomenclator.ordAmbitos.map(amb => {
      return {
        nombre: nombreEleccion[amb],
        url: `/estadisticas/${nombreEleccion[amb]}`,
      };
    })
    : elections.map(election => {
      return {
        nombre: nomEleccionAmbitos[election.eleccion],
        url: election.url,
      };
    });

  const isMountedRef = useRef(true);
  useEffect(() => {
    if (isOpen) {
      openMenu(wrapperId, { focusMenu: false });
    } else {
      closeMenu(wrapperId, { focusMenu: false });
    }
    return () => (isMountedRef.current = false);
  }, [isOpen, wrapperId]);

  return (
    <ContainerPropiedades>
      <SWrapper id={wrapperId}
        onMenuToggle={() => {
          isOpen = !isOpen;
          setIsOpen(isOpen);
        }}>
        <SButton>
          <TitleContainer>
            {title && title}
            <ButtonArrow variant={isOpen ? 'up' : 'down'} />
          </TitleContainer>
        </SButton>
        <SMenu>
          {propiedades.map((propiedad, i) => {
            return (
              <SMenuItem key={propiedad.nombre} value={propiedad.nombre}>
                <StyledLink to={propiedad.url}>{propiedad.nombre}</StyledLink>
              </SMenuItem>
            );
          })}
        </SMenu>
      </SWrapper>
    </ContainerPropiedades>
  );
};

export default DropdownElecciones;

const ContainerPropiedades = styled(({ primerColor, ...rest }) => (
  <div {...rest} />
))`
  display: flex;
  width: 100%;
  justify-content: space-between;
`;

const SWrapper = styled(Wrapper)`
  width: 100%;
  position: relative;
  margin-top: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
`;

const SButton = styled(Button)``;

const SMenu = styled(Menu)`
  position: absolute;
  width: 280px;
  top: 3rem;
  z-index: 30;
  background: white;
  border-radius: 25px;
  overflow: hidden;
  text-transform: uppercase;
  font-size: 1.4rem;
  font-weight: 800;
  box-shadow: 0px 2px 2px 2px rgb(0,0,0,0.16);

  & > * {
    text-align: center;
  }

  & > *:not(:last-child) {
    border-bottom: 2px solid rgb(0,0,0,0.2);
  }


  @media (max-width: ${responsive.maxWidth.mobile}px) {
    width: 200px;
  }
`;

const SMenuItem = styled(MenuItem)`
  cursor: pointer;
  color:#164192;
  :hover {
    background-color: rgb(0,0,0,0.04);
  }
`;

const StyledLink = styled(Link)`
  box-sizing: border-box;
  font-weight: bold;
  font-size: 1.4rem;
  padding: 0.8rem 1rem;
  text-transform: uppercase;
  text-decoration: none;
  width: 100%;
  height: 100%;
  display: block;
  color: inherit;
  &:hover {
    text-decoration: none;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  justify-content: start;
  align-items: center;
  gap:0.8rem;
  pointer-events: none;

  &:hover{
    color: #215CCC;
  }

  @media (max-width: ${responsive.maxWidth.tablet}px) {
    cursor: pointer;
    pointer-events: auto;
  }
`